import { GroupV1PortInStatuses } from './states'

export type Message = {
  type: 'info' | 'alert' | 'error'
  message: string
  code?: string | undefined
}

export type CodeType = 'pac' | 'stac'

export type PacOrStacData = {
  availableDates: Date[]
  expiryDate: string
  messages: Message[]
  requestActivationBy: string
}

export enum PortInStatuses {
  PORT_REQUESTED = 'port_requested',
  PORT_SUCCESS = 'port_success',
  PORT_FAILURE = 'port_failure',
  PORT_CANCELLED = 'port_cancelled', // we might have it triggered by Mobile app
  MAYBE_PORT_AFTER_ORDER = 'maybe_port_after_order', // order placed with port-in details, but
  // activation occurs when PAC already not valid
}

export interface PortInDetails {
  id: string
  code: string
  code_type: CodeType
  code_expiration: string | null
  requested_portin_date: string | null
  new_msisdn: string
  status: PortInStatuses | GroupV1PortInStatuses
  created_at: string
  submitted_at: string | null
  completed_at: string | null
  expected_completion_date: string
}

export enum MessageCodes {
  PORT_IN_VALIDATE_ERROR = 'port-in-validate-error',
  PORT_IN_STAC_ALERT = 'port-in-stac-alert',
  PORT_IN_EXPIRED_ERROR = 'port-in-expired-error',
  PORT_IN_CODE_USED_ERROR = 'port-in-code-used-error',
  PORT_IN_RECHECK_ERROR = 'port-in-recheck-error',
  PORT_IN_DATE_INVALID_ERROR = 'port-in-date-invalid-error',
  PORT_IN_DATE_FORMAT_ERROR = 'port-in-date-format-error',
  PORT_IN_EXPIRE_SOON_ERROR = 'port-in-expire-soon-error',
  PORT_IN_EXPIRE_SOON_ALERT = 'port-in-expire-soon-alert',
  PORT_IN_VALID_ALERT = 'port-in-valid-alert',
  PORT_IN_CODE_ERROR = 'port-in-code-error',
  PORT_IN_NUMBER_ERROR = 'port-in-number-error',
}
